export const SET_ERROR_PAGE = 'SET_ERROR_PAGE'
export const CLEAR_ERROR_PAGE = 'CLEAR_ERROR_PAGE'
